import { ref } from "vue";

export type RecoveryHeroKey = "form" | "sent";

const recoveryHeroKey = ref<RecoveryHeroKey>("form");

export function useRecoveryHero() {
  function setRecoveryHero(key: RecoveryHeroKey) {
    recoveryHeroKey.value = key;
  }

  function resetRecoveryHero() {
    recoveryHeroKey.value = "form";
  }

  return { recoveryHeroKey, setRecoveryHero, resetRecoveryHero };
}
